let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("dlmud")).then(() => parcelRequire('imT4f'));